import React from 'react';
import { FloatingNav } from '../components/FloatingNav';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { ModulesSection } from '../components/ModulesSection';
import { PricingSection } from '../components/PricingSection';
import { BeforeAfter } from '../components/BeforeAfter';
import { DifferentiationSection } from '../components/DifferentiationSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCta } from '../components/FinalCta';
import { FaqSection } from '../components/FaqSection';
import { Footer } from '../components/Footer';
import { PurchaseNotifications } from '../components/PurchaseNotifications';
export function LandingPage() {
  return <>
      <FloatingNav data-id="element-342" />
      <main className="w-full min-h-screen smooth-scroll" data-id="element-343">
        <Hero data-id="element-344" />
        <ProblemSection data-id="element-345" />
        <ModulesSection data-id="element-346" />
        <PricingSection data-id="element-347" />
        <BeforeAfter data-id="element-348" />
        <DifferentiationSection data-id="element-349" />
        <GuaranteeSection data-id="element-350" />
        <FinalCta data-id="element-351" />
        <FaqSection data-id="element-352" />
      </main>
      <Footer data-id="element-353" />
      <PurchaseNotifications data-id="element-354" />
    </>;
}